import { useAppDispatch } from "cache/store";
import { cacheMenuGame } from "features/msgSystemSlice";
import { MenuHeaderItem } from "models/commonModel";
import { useEffect } from "react";
import styles from "./layout.style";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import { menuList } from "interfaces/menuList";

interface Props {
    children: JSX.Element;
}

const menuInit: MenuHeaderItem[] = [
    {
        name: 'Trang chủ',
        child: null,
        isMain: true,
        path: '/',
        icon: "home-icon"
    }
];

function MainLayout(props: Props) {
    const { children } = props;
    const dispatch = useAppDispatch();

    useEffect(() => {
        const initMenuGame = async () => {
            const newMenuGame = [
                ...menuInit,
                ...menuList,
                {
                    name: 'Khuyến Mãi',
                    child: null,
                    isMain: true,
                    path: '/Promotion',
                    icon: "promotion"
                },
            ];
            dispatch(cacheMenuGame(newMenuGame));
        };
        initMenuGame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className={styles.wrap}>
            <Header />

            <div className={styles.body}>{children}</div>
            <Footer />
        </div>
    )
}

export default MainLayout;